<template>
  <div>
    <Header></Header>
    <div class="advisory">
      <div class="list">
        <div class="list-name">咨询分类：</div>
        <div class="list-cont" v-for="(tab,index) in tabs" :key="index">{{tab.name}}</div>
      </div>
      <div class="nav">
        <div class="jingpin">为您推荐</div>
        <ul>
          <li
            v-for="(tab,index) in tabs"
            :key="index"
            @click="toggle(index,tab.id,1)"
            :class="{active:active==index}"
          >{{tab.name}}</li>
        </ul>
      </div>
      <div class="tab-list">
        <div class="tablist-cont" v-for="(list,index) in lists" :key="index" @click="goadetails(list.id)">
          <img class="touxiang" :src="list.image" alt />
          <div class="center" >
            <div class="name">{{list.name}}</div>
            <div class="mc">
              <img src="../../assets/img/jiangs.png" alt />
              {{list.the_title}}
            </div>
            <div class="jianjie">{{list.intro}}</div>
          </div>
          <div class="right">
            <img src="../../assets/img/dh.png" alt />
            预约咨询
          </div>
        </div>
      </div>
      <div style="margin:0 auto;width:800px;text-align:center;margin-bottom:14px;">
        <el-pagination
          background
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="pageSize"
          layout=" prev, pager, next"
          :total="totalNum"
        ></el-pagination>
      </div>
    </div>
    <!-- <div class="login" v-if="popuo==0">
      <div class="tanch">
        <div class="login-pages bdzfb">
          <span class="title">咨询需求</span>
          <input type="text" v-model="inputz" placeholder="请输入联系人" />
          <input type="text" v-model="inputzxm" placeholder="请输入联系电话" />
          <textarea
            maxlength="200"
            placeholder="写下您的咨询备注，专家可以更具针对性的疏导"
            v-model="remark"
            @input="handleChange()"
            id="memo"
            style="min-height: 175px;min-width: 342px;max-height: 175px; max-width: 342px;"
          ></textarea>
          <div class="choiceBtn">
            <div class="btn" @click="off" round>取消</div>
            <div class="btn bd" @click="tijiao" round>申请咨询</div>
          </div>
        </div>
      </div>
    </div>
    <div class="login1" v-if="popuo==2">
      <div class="tanch">
        <div class="login-pages txwin">
          <img src="../../assets/img/zfcg@2x.png" alt />
          <div class="msg">
            <span>
              申请成功
              <br />请等待相关人员与您取得联系
            </span>
          </div>
          <div class="choiceBtn">
            <div round @click.stop="off" class="btn">关闭</div>
            <div round @click.stop="totx" class="btn bd">返回首页</div>
          </div>
        </div>
      </div>
    </div> -->

    <!--这里是半透明背景层-->
    <!-- <div class="over" v-show="popuo!=1"></div>
    <Login v-show="popuo==1"  :title='title'></Login> -->
  </div>
</template>

<script>
import Header from "../header";
import Footer from "../footer";
import Login from "../popup/login";
export default {
  name: "",

  data() {
    return {
      inputz: "",
      inputzxm: "",
      remark: "",
      popuo: "",
      id: "",
      title:"1",
      //老版本
      active: 0,
      currentView: "tab1",
      tabs: [],
      lists: [],
      currentPage: 1, //默认显示第一页
      pageSize: 6, //默认每页显示条
      totalNum: 0 //总页数
    };
  },
  created() {
    this.id = this.$route.query.id;
    if (!JSON.parse(sessionStorage.getItem("data"))) {
      this.popuo = 1;
    }
  },
  methods: {
    off() {
      this.popuo = 1;
      this.$router.push({
        path: "/"
      });
    },
    handleChange() {
      if (this.remark.length >= 200) {
        this.$message({
          type: "error",
          message: "最多两百字哦"
        });
      }
    },
    async tijiao() {
      if (this.inputz && this.inputzxm && this.remark) {
        if (
          !/^((1[3,5,8][0-9])|(14[5,7])|(17[0,6,7,8])|(19[7]))\d{8}$/.test(
            this.inputzxm
          )
        ) {
          this.$message({
            type: "error",
            message: "填写正确的手机号"
          });
        } else {
          var uid = JSON.parse(sessionStorage.getItem("data"));
          await this.$service.home
            .consultform({
              uid: uid.id,
              name: this.inputz,
              phone: this.inputzxm,
              remark: this.remark
            })
            .then(res => {
              console.log(res);
              if (res.data.code == 200) {
                this.popuo = 2;
              }
            })
            .catch(err => {
              console.log(err);
            });
        }
      } else {
        this.$message({
          type: "error",
          message: "填写信息不能为空"
        });
      }
    },
    totx() {
      this.$router.push({
        path: "/"
      });
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.currentPage = val; //动态改变
      this.toggle(this.active, this.currentView);
    },
    // 咨询分类
    async consult_type_list() {
      await this.$service.home
        .consult_type_list({})
        .then(res => {
          if (res.data.code == 200) {
            this.tabs = res.data.content;
            // 默认
            this.currentView = res.data.content[0].id;
            this.toggle();
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 老师列表
    async toggle(i, v, p) {
      console.log(i, v, p);
      if (p) {
        this.currentPage = p;
      }
      if (i == undefined) {
        this.active = 0;
      } else {
        this.active = i;
        this.currentView = v;
      }
      var type_id = this.currentView;
      await this.$service.home
        .consult_teacher({
          type_id: type_id,
          page: this.currentPage,
          page_count: this.pageSize
        })
        .then(res => {
          console.log(res.data.content);
          if (res.data.code == 200) {
            this.lists = res.data.content.list;
            // 向上取整数
            var totalNum = Math.ceil(res.data.content.count);
            this.totalNum = totalNum;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    goadetails(id) {
      console.log(id);
      this.$router.push({
        path: "/advi_details",
        query: {
          id: id
        }
      });
    }
  },
  components: {
    Header,
    Footer,
    Login
  },
  mounted() {
    this.consult_type_list();
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  lang="less"  scoped>
.login {
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 1000;
  display: flex;
  width: 400px;
  height: 504px;
  background: rgba(255, 255, 255, 1);
  border-radius: 10px;
}
.login1 {
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 1000;
  display: flex;
  width: 400px;
  height: 400px;
  background: rgba(255, 255, 255, 1);
  border-radius: 10px;
}
.over {
  position: fixed;
  width: 100%;
  height: 100%;
  opacity: 0.5;
  filter: alpha(opacity=50);
  top: 0;
  left: 0;
  z-index: 999;
  background-color: #111111;
}
.tanch .login-pages .choiceBtn {
  display: flex;
  justify-content: space-around;
  bottom: 34px;
  height: 42px;
  align-items: flex-end;
}
.tanch .login-pages .choiceBtn .btn {
  width: 156px;
  height: 42px;
  background: rgba(179, 179, 179, 1);
  border-radius: 25px;
  text-align: center;
  line-height: 42px;
  color: #ffffff;
  font-size: 16px;
}
.tanch .login-pages .choiceBtn .bd {
  background: rgba(23, 117, 239, 1);
}

.bdzfb {
  height: 225px !important;
  padding: 30px 29px 34px 29px !important;
  position: relative;
}
.bdzfb .title {
  display: inline-block;
  width: 340px;
  font-size: 18px;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
  text-align: center;
  margin-bottom: 15px;
}
input,
textarea {
  width: 340px;
  height: 50px;
  background: rgba(244, 244, 244, 1);
  border-radius: 6px;
  border: none;
  margin-bottom: 30px;
}
::-webkit-input-placeholder,
::-webkit-textarea-placeholder {
  padding-left: 13px;
  font-size: 18px;
}
.tanch .login-pages .choiceBtn {
  display: flex;
  justify-content: space-around;
  bottom: 34px;
  height: 42px;
  align-items: flex-end;
}
.tanch .login-pages .choiceBtn .btn {
  width: 156px;
  height: 42px;
  background: rgba(179, 179, 179, 1);
  border-radius: 25px;
  text-align: center;
  line-height: 42px;
  color: #ffffff;
  font-size: 16px;
}
.tanch .login-pages .choiceBtn .bd {
  background: rgba(23, 117, 239, 1);
}
.txwin {
  height: 281px !important;
  padding: 22px 29px 31px 29px !important;
  position: relative;
  img {
    display: inline-block;
    margin: 0 auto;
    width: 144px;
    height: 144px;
    margin-top: 17px;
    display: flex;
    justify-content: center;
  }
}
.msg {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: center;
  text-align: center;
  margin-top: 22px;
  // position: absolute;
  span {
    width: 342px;
    font-size: 18px;
    color: rgba(51, 51, 51, 1);
    letter-spacing: 1px;
    font-family: PingFang-SC-Medium;
    &:nth-child(1) {
      margin-bottom: 7px;
    }
  }
}
.advisory {
  width: 1200px;
  margin: 0 auto;
}
.list {
  width: 1200px;
  height: 100px;
  margin-top: 16px;
  background: rgba(255, 255, 255, 1);
  border-radius: 3px;
  border: 1px solid rgba(237, 237, 237, 1);
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.list .list-name {
  font-size: 16px;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 22px;
}
.list .list-cont {
  width: 136px;
  height: 74px;
  border-radius: 6px;
  font-size: 16px;
  font-weight: bold;
  color: rgba(255, 255, 255, 1);
  line-height: 74px;
  text-align: center;
}
.list div:nth-child(2) {
  background-image: url("../../assets/img/1c.png");
}
.list div:nth-child(3) {
  background-image: url("../../assets/img/2c.png");
}
.list div:nth-child(4) {
  background-image: url("../../assets/img/3c.png");
}
.list div:nth-child(5) {
  background-image: url("../../assets/img/4c.png");
}
.list div:nth-child(6) {
  background-image: url("../../assets/img/5c.png");
}
.list div:nth-child(7) {
  background-image: url("../../assets/img/3c.png");
}
.list div:nth-child(8) {
  background-image: url("../../assets/img/6c.png");
}
.nav {
  margin: 0 auto;
  display: flex;
  align-items: center;
}
.nav .jingpin {
  font-size: 24px;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
  line-height: 33px;
}
.nav ul {
  width: 800px;
  display: inline-flex;
  justify-content: space-around;
}
.nav ul li {
  font-size: 16px;
  font-weight: 500;
  color: rgba(102, 102, 102, 1);
  line-height: 22px;
}
.nav ul li.active {
  color: #1775ef;
}
.tab-list {
  width: 1200px;
  background: rgba(255, 255, 255, 1);
  border-radius: 3px;
}
.tab-list .tablist-cont {
  height: 200px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  margin-left: 20px;
  border-bottom: 1px solid #ededed;
}
.tab-list .tablist-cont img.touxiang {
  width: 126px;
  height: 160px;
  border-radius: 6px;
  margin-right: 10px;
}
.tab-list .tablist-cont .center {
  height: 160px;
  margin-right: 219px;
  width: 685px;
}
.tab-list .tablist-cont .center .name {
  font-size: 20px;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 28px;
  letter-spacing: 1px;
  margin-bottom: 6px;
}
.tab-list .tablist-cont .center .mc {
  font-size: 14px;
  font-weight: 500;
  color: rgba(136, 136, 136, 1);
  line-height: 20px;
  margin-bottom: 26px;
}
.tab-list .tablist-cont .center .jianjie {
  width: 685px;
  height: 40px;
  font-size: 14px;
  font-family: PingFang-SC-Medium, PingFang-SC;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 20px;
  white-space: nowrap;
  text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
  overflow: hidden;
}
.tab-list .tablist-cont .right {
  width: 120px;
  height: 35px;
  background: rgba(20, 133, 238, 1);
  border-radius: 18px;
  font-size: 16px;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  line-height: 35px;
  text-align: center;
} 
</style>



// WEBPACK FOOTER //
// src/components/zixun/advisory.vue